export const GMAIL = "info@bhuorder.com";
export const WHATSAPP_LINK = "https://wa.me/message/37C2FWTVJS4EK1";
